import { useLoaderStore } from '@/shared/store/useLoaderStore.ts';
import { useDelayedSkeleton, useSkeletonAnimation } from '@experience/core-skeleton-lib';
import { SKELETON_APPEARANCE_DELAY, SKELETON_MIN_VISIBLE_DURATION } from '@/shared/consts';

export const useListingSkeleton = (_delay = SKELETON_APPEARANCE_DELAY, minVisible = SKELETON_MIN_VISIBLE_DURATION) => {
  const loaderStore = useLoaderStore();
  const { isPageInitialLoad } = useSkeletonAnimation();

  const actualDelay = 0;
  const actualMinVisible = isPageInitialLoad.value ? 0 : minVisible;

  const { isActive } = useDelayedSkeleton(() => loaderStore.isFiltersLoading, actualDelay, actualMinVisible);

  return { isSkeletonActive: isActive };
};
